(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-banner"] && !Shopify.designMode) return;
  try {
    
  Array.from(document.querySelectorAll("[data-scrollto]")).forEach((trigger) => {
  trigger.addEventListener("click", (event) => {
    event.preventDefault();

    const targetId = trigger.getAttribute("data-scrollto");
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

  } catch(e) { console.error(e); }
})();
})();
